'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dialogs;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dialogs(openCallback, closeCallback) {
  return {
    prompt: function prompt(question) {
      return new _bluebird2.default(function (resolve, reject) {
        var component = _react2.default.createElement(_components.Prompt, { question: question, onCloseYes: resolve, onCloseNo: reject });

        openCallback(component);
      }).catch(function (err) {}).finally(closeCallback);
    },

    custom: function custom(component) {
      return new _bluebird2.default(function (resolve, reject) {
        openCallback(_react2.default.cloneElement(component, {
          onCloseYes: resolve,
          onCloseNo: reject
        }));
      }).catch(function (err) {}).finally(closeCallback);
    }
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/dialogs.jsx
// module id = 2875
// module chunks = 0